import { OrderRecordService } from "@/api/service-proxies";

export const orderRecordService = new OrderRecordService();
